import { Stack } from '@mantine/core';
import { useRef } from 'react';
import i18n from '../../../../../base-dictionary';
import { ContentPlaceholder } from '../../../../../components/content-placeholder/content-placeholder';
import { useTargetsTabStore } from '../../../../../store/strategy-store/strategy-store';
import { MainSectionControls } from '../../components/main-section-controls/main-section-controls';
import { TargetsChart } from './targets-chart/targets-chart';

export const MainSection = () => {
  const targets = useTargetsTabStore((state) => state.targets);
  const selectedTarget = useTargetsTabStore((state) => state.selectedTarget);

  const chartRef = useRef<HTMLDivElement>(null!);

  const sectionHeader = selectedTarget ? (
    <MainSectionControls title={`${selectedTarget.name} Target`} chartRef={chartRef} />
  ) : (
    <MainSectionControls
      title={i18n.t('strategy.initiative_performance.targets')}
      chartRef={chartRef}
      disableControls
    />
  );

  const content =
    targets.length > 0 && selectedTarget ? (
      <TargetsChart ref={chartRef} />
    ) : (
      <ContentPlaceholder icon="add_circle_outline" text={i18n.t('strategy.initiative_performance.add_target')} />
    );

  return (
    <Stack h="100%" style={{ overflow: 'hidden', position: 'relative' }}>
      {sectionHeader}
      {content}
    </Stack>
  );
};
